
export default {
  isLoading: false,
  login: {},
};
